/**
 * @file This file is migrated from Jira monolith (`jira-components/jira-legacy-frontend/jira-quick-edit-plugin-frontend/src/main/resources/jira-quick-edit-plugin/js/init/calendar.js`)
 *
 * Old AMD key: `quick-edit/init/calendar`
 */
import { type Locale, defaultLocale } from '@atlassian/jira-common-constants/src/supported-locales';
import { asyncWrmRequire, calendarLocaleModule } from '@atlassian/jira-wrm';
import { getMeta } from '../../../common';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const getLocale = (): Locale => (getMeta('user-locale') as Locale) || defaultLocale;

export type CallbackFn = () => void;

export const loadCalendarResources = (cb: CallbackFn) => {
	const locale = getLocale();
	const wrmKey = calendarLocaleModule(locale);
	asyncWrmRequire([wrmKey]).then(cb);
};
